import { render, staticRenderFns } from "./Trophy.vue?vue&type=template&id=7ead1224&scoped=true"
import script from "./Trophy.vue?vue&type=script&lang=js"
export * from "./Trophy.vue?vue&type=script&lang=js"
import style0 from "./Trophy.vue?vue&type=style&index=0&id=7ead1224&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ead1224",
  null
  
)

export default component.exports